import { CssBaseline, AppBar, Toolbar } from '@mui/material'
import { Toaster } from 'react-hot-toast'
import Toast from 'src/components/Toast'
import useUploadEventListeners from 'src/hooks/useUploadEventListeners'
import WingWorkAppBarLogo from 'src/layouts/components/WingWorkAppBarLogo'

type FormSubmissionLayoutProps = {
  children?: React.ReactNode
}

const FormSubmissionLayout = ({ children }: FormSubmissionLayoutProps) => {
  useUploadEventListeners()

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}
    >
      <CssBaseline />

      <AppBar
        position="static"
        className="bg-transparent shadow-none"
        color="inherit"
        elevation={1}
      >
        <Toolbar>
          <WingWorkAppBarLogo visible={true} />
        </Toolbar>
      </AppBar>

      <main className="flex-grow bg-transparent px-2 shadow-none">
        {children}
      </main>

      <Toaster position="top-right" containerClassName="mt-7 z-51">
        {(t) => <Toast t={t} message={t.message} />}
      </Toaster>
    </div>
  )
}

export default FormSubmissionLayout
